import { Image } from "antd";
import React, { useEffect, useState } from "react";
import config from "@/config";
import { FaMapMarkerAlt, FaMoneyBillWave, FaUsers, FaUserTie } from "react-icons/fa";
import QRCode from 'qrcode';


export const DetailJobTitle = ({ job }) => {
    const [QR, setQR] = useState();
    async function generateQRCodeBase64(url) {
        try {
            const qrBase64 = await QRCode.toDataURL(url, {
                color: {
                    dark: '#000000', // Màu QR
                    light: '#ffffff' // Màu nền
                }
            });
            return qrBase64;
        } catch (err) {
            console.error('Lỗi tạo QR code:', err);
            return null;
        }
    }

    // Gọi hàm và in kết quả
    useEffect(() => {
        generateQRCodeBase64(`https://vieclamsanxuat.vercel.app/${config.routes.job}/${job.Pk}`).then(qrImage => {
            setQR(qrImage)
        });
    }, [job]);

    return (
        <div className="hidden lg:flex items-center mt-24 ml-20 w-full justify-center">
            <div className={"flex flex-col w-full"}>
                <h2 className="text-2xl font-bold">{job.JobTitle}</h2>
                <p className="text-gray-500">{job.JobCompanyName}</p>
                <div className="w-full grid grid-cols-2  gap-4 mt-4">
                    <div className="flex items-center">
                        <div className="w-16 h-16 rounded-full p-3.5 shadow-lg bg-white border border-primary shrink-0">
                            <FaMoneyBillWave className="w-full h-full text-primary" />
                        </div>
                        <div className="ml-4">
                            <h3 className="text-lg font-semibold">Thu nhập</h3>
                            <p>{job.JobSalary ? /^\d+$/.test(job.JobSalary) ? `${(+job.JobSalary).toLocaleString('vi-VN')}` : job.JobSalary : "Thỏa thuận"}</p>
                        </div>
                    </div>
                    <div className="flex items-center">
                        <div className="w-16 h-16 rounded-full p-3.5 shadow-lg bg-white border border-primary shrink-0">
                            <FaMapMarkerAlt className="w-full h-full text-primary " />
                        </div>

                        <div className="ml-4">
                            <h3 className="text-lg font-semibold">Địa điểm</h3>
                            <p>{job.WorkPlace || "Liên Hệ"}</p>
                        </div>
                    </div>
                    <div className="flex items-center">
                        <div className="w-16 h-16 rounded-full p-3.5 shadow-lg bg-white border border-primary shrink-0">
                            <FaUserTie className="w-full h-full text-primary " />
                        </div>
                        <div className="ml-4">
                            <h3 className="text-lg font-semibold">
                                Vị trí cần tuyển
                            </h3>
                            <p>{job.JobPosition || "Liên Hệ"}</p>
                        </div>
                    </div>
                    <div className="flex items-center">
                        <div className="w-16 h-16 rounded-full p-3.5 shadow-lg bg-white border border-primary shrink-0">
                            <FaUsers className="w-full h-full text-primary " />
                        </div>
                        <div className="ml-4">
                            <h3 className="text-lg font-semibold">Số lượng cần tuyển</h3>
                            <p>{job.JobQuantity ? `${job.JobQuantity} người` : "Liên Hệ"}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="hidden xl:flex flex-col items-center">
                <Image
                    width={200}
                    src={QR}
                    className="border border-gray-50 shadow-xl"
                />
                <a href={QR} download
                    className="text-cyan-400 mt-3 font-bold text-xl hover:underline hover:cursor-pointer">Tải
                    về</a>
            </div>
        </div>
    )
}